import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getHousehold = encounterId =>
    createAction("GET_HOUSEHOLD", () =>
        Axios.get(`/api/encounters/${encounterId}/household/MAGI`)
            .then(data => data.data)
            .catch(err => {
                if (err.response.status === 404) {
                    return {};
                } else {
                    throw err;
                }
            })
    );

export const getHouseholds = encounterId =>
    createAction("GET_HOUSEHOLDS", () =>
        Axios.get(`/api/encounters/${encounterId}/households`).then(data => data.data)
    );
